import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { StarRating } from '../ui/StarRating';
const testimonials = [{
  text: 'Compré el Kit un domingo. El lunes fabricaba 4 soportes de laptop. Miércoles ya había vendido 3 por Wallapop. Increíble.',
  name: 'Antonio R.',
  role: 'Carpintero · Málaga'
}, {
  text: 'Pensé que era otro PDF teórico más. Pero esto es diferente. Los planos son claros, las medidas exactas. Ya fabrico 2 torres Montessori a la semana.',
  name: 'Paco J.',
  role: 'Manitas · Madrid'
}, {
  text: 'Lo que más me gustó fue el Bono de Precios. Por fin sé cuánto cobrar sin sentirme ladrón. Gano 60€ de margen por tabla.',
  name: 'Laura G.',
  role: 'Profesora y Artesana · Zaragoza'
}, {
  text: 'Las plantillas de Wallapop funcionan. Publico, y al día siguiente tengo consultas serias. Sin regateo.',
  name: 'Iñaki A.',
  role: 'Bilbao'
}, {
  text: 'El Radar Antidesperdicio me ahorró fabricar 3 productos que nadie hubiera comprado. Ahora solo hago lo que vende.',
  name: 'Sergio B.',
  role: 'Valencia'
}, {
  text: 'El Pack Cliente Feliz cambió todo. Mis clientes ahora dejan reseñas de 5 estrellas y me recomiendan a sus amigos. Puse las tarjetas de cuidado y la diferencia fue instantánea.',
  name: 'María C.',
  role: 'Barcelona'
}];
export function Testimonials() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-201" data-mp="1euz59hf9gmgx">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-202" data-mp="2bjn9nay20b7v">
        <SectionTag icon="⭐" data-id="element-203" data-mp="26kanksf0b86c">Testimonios reales</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-204" data-mp="26ktw5iirok7p">
          Carpinteros y Manitas de toda España ya están facturando.
        </h2>
        <div className="mt-4 flex items-center justify-center gap-2" data-id="element-205" data-mp="1xiuc0hcgh00j">
          <StarRating size={18} data-id="element-206" data-mp="r437m3o4ix1r" />
          <span className="text-sm text-muted" data-id="element-207" data-mp="r4bn83bmsggn">+320 reseñas verificadas</span>
        </div>
      </div>

      <div className="mx-auto mt-8 grid max-w-6xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3" data-id="element-208" data-mp="m2vz22e5ptu1">
        {testimonials.map((t, i) => <m.div key={t.name} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className="flex flex-col rounded-2xl border border-brown/20 bg-white p-6 shadow-card" data-id="element-209" data-mp="njtbqjff03fr" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-210" data-mp="4uv4cjv3i931">
              <StarRating size={14} data-id="element-211" data-mp="9luyxigqsf2d" />
              <span aria-hidden="true" data-id="element-212" data-mp="9mwkigvdwjyc">🇪🇸</span>
            </div>
            <p className="mt-3 flex-1 text-sm leading-relaxed text-ink/90" data-id="element-213" data-mp="3r2mk8htc6232">"{t.text}"</p>
            <div className="mt-4 border-t border-brown/10 pt-3" data-id="element-214" data-mp="3w1fmtf7348og">
              <p className="text-sm font-semibold text-ink" data-id="element-215" data-mp="3w1z9f97ojl8t">{t.name}</p>
              <p className="text-xs text-muted" data-id="element-216" data-mp="3i2pqi1s3ad15">{t.role}</p>
            </div>
          </m.div>)}
      </div>

      <p className="mt-6 text-center text-sm text-muted sm:text-base" data-id="element-217" data-mp="3mzpzolk8jvwh">
        Más de <span className="font-semibold text-brown" data-id="element-218" data-mp="33eg0qmik332p">5.200 piezas vendidas</span> por artesanos que ya
        usan EL KIT DEL TALLER RENTABLE.
      </p>
    </section>;
}